import { render, staticRenderFns } from "./ManageStaffSkills.vue?vue&type=template&id=9a20af4e&scoped=true&"
import script from "./ManageStaffSkills.vue?vue&type=script&lang=js&"
export * from "./ManageStaffSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a20af4e",
  null
  
)

export default component.exports